type RellaxData = {
  [key: string]: string | number; // Allows any string key with a string or number value
};
type Props = {
  label: string;
  href: string;
  style?: React.CSSProperties;
  rellaxData?: RellaxData;
  className?: String;
};

const Button = (props: Props) => {
  return (
    <a
      {...props.rellaxData}
      href={props.href}
      className={`
        ${props.className} 
        ${props.rellaxData ? "rellax" : ""} 
            relative inline-block py-1.5 text-white before:absolute before:inset-0 before:origin-bottom before:scale-y-[.03] before:bg-white/60 before:transition before:duration-300 hover:before:scale-y-100 hover:before:scale-x-125 hover:before:bg-white/10 `}
      style={props.style}
    >
      <span className="relative">{props.label}</span>
    </a>
  );
};

export default Button;
